import React from "react";

import { StyledButton, ButtonProps } from "./styled";

export type PresenterProps = {
  text: string;
  disabled?: boolean;
  type?: React.ComponentProps<"button">["type"];
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
} & ButtonProps;

export const ButtonPresenter: React.FC<PresenterProps> = ({
  text,
  disabled,
  onClick,
  ...rest
}) => {
  return (
    <StyledButton disabled={disabled} onClick={onClick} {...rest}>
      {text}
    </StyledButton>
  );
};

ButtonPresenter.defaultProps = {
  size: "large",
  variant: "primary",
};
